<template>
    <div
        class="tutorialSpotlight"
        v-bind:class="{ _labeled: label }"
        v-bind:style="spotlightStyle"
    >
        <span v-if="label">{{ label }}</span>
    </div>
</template>

<script lang="ts" setup>
    import { useElementBounding } from '@vueuse/core';
    import { computed, toRefs } from 'vue';

    const props = withDefaults(defineProps<{
        target: HTMLElement | null;
        label?: string;
    }>(), {
        label: '',
    });

    const { target } = toRefs(props);
    const { top, left, width, height } = useElementBounding(target);

    const spotlightStyle = computed(() => ({
        top: `${top.value}px`,
        left: `${left.value}px`,
        width: `${width.value}px`,
        height: `${height.value}px`,
    }));
</script>

<style lang="scss" scoped>
@import "@/scss/components/betSlipTutorial/tutorialSpotlight";
</style>
